// El catálogo de bases del modo Diseño — ADR-2026-09-18-las-bases-son-los-dibujos-de-freesewing.
//
// Cada base es el plano de FRENTE de un diseño de FreeSewing (https://freesewing.eu): los
// "line drawings" de `@freesewing/react` (MIT, ver `LICENSE-FreeSewing.txt` junto a los
// PNG), rasterizados a PNG con `scripts/bases-freesewing/render.mjs`. El id es el nombre
// del diseño en FreeSewing, así cada base sigue apuntando a su molde paramétrico por si
// algún día se dibuja (ADR-2026-09-18-las-bases-son-los-dibujos-de-freesewing). Quedan
// afuera los peluches, los disfraces y Crux (su dibujo es punteado y confunde al motor).
// El PNG es lo que se sube y lo que el motor recibe: los motores de imagen no leen SVG.

export const CATEGORIAS_DE_BASES = ['Superior', 'Abrigo', 'Inferior', 'Vestidos', 'Interior y baño', 'Accesorios'] as const;
export type CategoriaDeBase = (typeof CATEGORIAS_DE_BASES)[number];

export interface BaseDeIndumentaria {
  id: string;
  nombre: string;
  categoria: CategoriaDeBase;
  /** Ruta pública del PNG. */
  archivo: string;
}

const CARPETA = '/images/modo_diseno_indumentaria/bases';
const base = (id: string, nombre: string, categoria: CategoriaDeBase): BaseDeIndumentaria => ({
  id,
  nombre,
  categoria,
  archivo: `${CARPETA}/${id}.png`,
});

export const BASES_DE_INDUMENTARIA: BaseDeIndumentaria[] = [
  // ── Superior
  base('teagan', 'Remera', 'Superior'),
  base('aaron', 'Musculosa', 'Superior'),
  base('bibi', 'Top de punto', 'Superior'),
  base('toni', 'Top ajustado', 'Superior'),
  base('tristan', 'Top con corte princesa', 'Superior'),
  base('diana', 'Top cuello volcado', 'Superior'),
  base('tina', 'Top cruzado', 'Superior'),
  base('simon', 'Camisa', 'Superior'),
  base('simone', 'Camisa femenina', 'Superior'),
  base('brian', 'Remera manga larga', 'Superior'),
  base('bent', 'Remera manga larga entallada', 'Superior'),
  base('bella', 'Cuerpo base femenino', 'Superior'),
  base('breanna', 'Cuerpo base femenino corto', 'Superior'),
  base('noble', 'Cuerpo base con corte princesa', 'Superior'),
  // ── Abrigo
  base('sven', 'Buzo cuello redondo', 'Abrigo'),
  base('hannah', 'Buzo con capucha', 'Abrigo'),
  base('hugo', 'Buzo con capucha raglán', 'Abrigo'),
  base('huey', 'Campera con capucha y cierre', 'Abrigo'),
  base('jett', 'Campera bomber', 'Abrigo'),
  base('devon', 'Campera de jean', 'Abrigo'),
  base('yuri', 'Sweater', 'Abrigo'),
  base('wahid', 'Chaleco', 'Abrigo'),
  base('carlton', 'Tapado largo', 'Abrigo'),
  base('carlita', 'Tapado largo femenino', 'Abrigo'),
  base('lunetius', 'Capa', 'Abrigo'),
  // ── Inferior
  base('charlie', 'Pantalón chino', 'Inferior'),
  base('titan', 'Pantalón recto', 'Inferior'),
  base('waralee', 'Pantalón envolvente', 'Inferior'),
  base('cornelius', 'Breeches de ciclismo', 'Inferior'),
  base('shale', 'Short', 'Inferior'),
  base('ashley', 'Short de jean', 'Inferior'),
  base('percy', 'Short abullonado', 'Inferior'),
  base('lumira', 'Calza', 'Inferior'),
  base('lumina', 'Calza capri', 'Inferior'),
  base('penelope', 'Pollera tubo', 'Inferior'),
  base('sandy', 'Pollera plato', 'Inferior'),
  base('sarah', 'Pollera base', 'Inferior'),
  // ── Vestidos
  base('sophie', 'Vestido lencero', 'Vestidos'),
  base('onyx', 'Enterito', 'Vestidos'),
  base('otis', 'Body de bebé', 'Vestidos'),
  // ── Interior y baño
  base('bruce', 'Bóxer', 'Interior y baño'),
  base('uma', 'Bombacha', 'Interior y baño'),
  base('umbra', 'Bombacha clásica', 'Interior y baño'),
  base('cathrin', 'Corset', 'Interior y baño'),
  base('bee', 'Top de bikini', 'Interior y baño'),
  base('shin', 'Malla short', 'Interior y baño'),
  base('shelly', 'Remera de baño', 'Interior y baño'),
  // ── Accesorios
  base('trayvon', 'Corbata', 'Accesorios'),
  base('benjamin', 'Moño', 'Accesorios'),
  base('florent', 'Boina', 'Accesorios'),
  base('holmes', 'Gorra de caza', 'Accesorios'),
  base('hortensia', 'Cartera', 'Accesorios'),
  base('albert', 'Delantal', 'Accesorios'),
  base('bob', 'Babero', 'Accesorios'),
  base('lucy', 'Bolsillo de atar', 'Accesorios'),
  base('florence', 'Barbijo', 'Accesorios'),
];

export const baseDeIndumentaria = (id: string): BaseDeIndumentaria | undefined =>
  BASES_DE_INDUMENTARIA.find((b) => b.id === id);
